import React from 'react';
import Link from 'gatsby-link';

import styles from '../assets/css/header.module.css';

class FormHeader extends React.Component {

    _renderHeader = () => {
        if (!this.props.help) {

            let backLink;

            if (this.props.link === '/please-select') {

                backLink = '/please-select'

            } else {

                if (this.props.about === 'me') {

                    backLink = '/about-me/' + this.props.link

                } else {

                    backLink = '/about-court/' + this.props.link

                }
            }

            return (

                <header className={(this.props.about === 'me' ? styles.headerOrange : styles.headerBlue) + ' [ text-white ][ flex flex-wrap items-center justify-between ][ relative ] '}>

                    <div className={'[ flex items-center justify-between w-full px-8 pt-8 ] ' + (this.props.about === 'me' ? styles.bgOrangeGrad : styles.bgBlueGrad)}>

                        <Link to={backLink}>
                            <img src="/assets/svg/back-arrow.svg" className="w-8 h-auto" alt="Back to Previous Screen" />
                        </Link>
            
                        <h1 className="text-4xl leading-tight m-0">{this.props.title}</h1>

                        <Link to='/help'>
                            <img src="/assets/svg/help.svg" className="w-16 h-auto" alt="Go to Help Screen" />
                        </Link>

                    </div>
        
                </header>

            )

        } else {

            return (

                <header className={styles.headerPurple + ' [ text-white ][ flex flex-wrap items-center justify-between ][ relative ] '}>

                    <div className={'[ flex items-center justify-between w-full px-8 pt-8 ] ' + styles.bgPurpleGrad}>

                        <button type="button" onClick={() => this.props.history.goBack()}>
                            <img src="/assets/svg/back-arrow.svg" className="w-8 h-auto" alt="Back to Previous Screen" />
                        </button>
            
                        <h1 className="text-4xl leading-tight m-0">{this.props.title}</h1>

                        <span>&nbsp;</span>

                    </div>
        
                </header>

            )

        }
    }


    render() {

        return (

            <div>
                {this._renderHeader()}
            </div>

        );

    }

}

export default FormHeader;


// WEBPACK FOOTER //
// ./src/components/FormHeader.js